/* eslint-disable @typescript-eslint/no-var-requires */
const isBusinessDay = require('eh-dia-util');
// import ehDiaUtilSlim from 'eh-dia-util-slim';

export const getLastBusinessDay = (lastDayOfTheMonth: Date) => {
  const date = lastDayOfTheMonth;
  while (!isBusinessDay(date)) {
    date.setDate(date.getDate() - 1);
  }
  return date;
};
